if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.currentMediaIndex = 0;
      this.onLightboxClick = this.onLightboxClick.bind(this);
      this.onLightboxPointerUp = this.onLightboxPointerUp.bind(this);
      this.onLightboxKeydown = this.onLightboxKeydown.bind(this);

      // Capture navigation clicks before any other modal handlers see them.
      this.addEventListener('click', this.onLightboxClick, true);

      // Dawn's base media modal closes on mouse pointerup anywhere that is not
      // deferred media/model content. Stop that close behaviour for the image
      // area and carousel arrows so only the X (or Escape) closes the lightbox.
      this.addEventListener('pointerup', this.onLightboxPointerUp, true);
    }

    hide() {
      document.removeEventListener('keydown', this.onLightboxKeydown);
      if (window.pauseAllMedia) window.pauseAllMedia();
      super.hide();
    }

    show(opener) {
      super.show(opener);
      document.addEventListener('keydown', this.onLightboxKeydown);
      this.showActiveMedia();
    }

    getMediaItems() {
      return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
    }

    onLightboxPointerUp(event) {
      if (event.pointerType !== 'mouse') return;

      const isNavigation = event.target.closest('.product-media-modal__nav');
      const isMediaContent = event.target.closest('.product-media-modal__content');

      if (!isNavigation && !isMediaContent) return;

      event.stopPropagation();
      event.stopImmediatePropagation();
    }

    onLightboxClick(event) {
      const previousButton = event.target.closest('.product-media-modal__nav--prev');
      const nextButton = event.target.closest('.product-media-modal__nav--next');

      if (!previousButton && !nextButton) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (previousButton) this.showMediaByIndex(this.currentMediaIndex - 1);
      else this.showMediaByIndex(this.currentMediaIndex + 1);
    }

    onLightboxKeydown(event) {
      if (!this.hasAttribute('open')) return;
      if (event.code === 'ArrowLeft') {
        event.preventDefault();
        this.showMediaByIndex(this.currentMediaIndex - 1);
      }
      if (event.code === 'ArrowRight') {
        event.preventDefault();
        this.showMediaByIndex(this.currentMediaIndex + 1);
      }
    }

    showActiveMedia() {
      const mediaItems = this.getMediaItems();
      if (!mediaItems.length || !this.openedBy) return;

      const requestedId = this.openedBy.getAttribute('data-media-id');
      let requestedIndex = mediaItems.findIndex((item) => item.getAttribute('data-media-id') === requestedId);

      if (requestedIndex === -1 && requestedId) {
        const cleanId = requestedId.split('-').pop();
        requestedIndex = mediaItems.findIndex((item) => item.getAttribute('data-media-id') === cleanId);
      }

      this.showMediaByIndex(requestedIndex >= 0 ? requestedIndex : 0);
    }

    showMediaByIndex(index) {
      const mediaItems = this.getMediaItems();
      if (!mediaItems.length) return;

      this.currentMediaIndex = (index + mediaItems.length) % mediaItems.length;

      mediaItems.forEach((item, itemIndex) => {
        const isActive = itemIndex === this.currentMediaIndex;
        item.classList.toggle('active', isActive);
        item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      const counterCurrent = this.querySelector('.product-media-modal__counter-current');
      const counterTotal = this.querySelector('.product-media-modal__counter-total');
      if (counterCurrent) counterCurrent.textContent = this.currentMediaIndex + 1;
      if (counterTotal) counterTotal.textContent = mediaItems.length;
    }
  });
}
